import product1 from '../../images/product-1.png';
import product2 from '../../images/product-2.png';
import product3 from '../../images/product-3.png';
import sweet1 from '../../images/sweet3.png';
import sweet2 from '../../images/sweet-2.png';
import sweet3 from '../../images/sweet-3.png';

export const productData = [
  {
    img: product1,
    alt: 'coconutoil',
    name: 'Coconut Oil - Can Box & Tin ',
    desc:
      'தேர்ந்தெடுக்கப்பட்ட தேங்காயை தூய்மையான முறையில் இயற்கையான சூரிய ஔியில் காய வைத்து தயாரான தரமான கொப்பரையை கொண்டு பாரம்பரிய முறையில் செக்கில் ஆட்டிய நயம் தேங்காய் எண்ணெய்',
    qty: '',
    
    button: '5Kg/15Kg'
  },
  {
    img: product2,
    alt: 'coconutoil',
    name: 'COCONUT OIL - Cold Pressed Pouch ',
    desc:
    'தேர்ந்தெடுக்கப்பட்ட தேங்காயை தூய்மையான முறையில் இயற்கையான சூரிய ஔியில் காய வைத்து தயாரான தரமான கொப்பரையை கொண்டு பாரம்பரிய முறையில் செக்கில் ஆட்டிய நயம் தேங்காய் எண்ணெய்',
    qty: '',
    button: '1Ltr/500ml'
  },
  {
    img: product3,
    alt: 'coconutoil',
    name: 'COCONUT OIL - Cold Pressed Pouch ',
    desc:
    'தேர்ந்தெடுக்கப்பட்ட தேங்காயை தூய்மையான முறையில் இயற்கையான சூரிய ஔியில் காய வைத்து தயாரான தரமான கொப்பரையை கொண்டு பாரம்பரிய முறையில் செக்கில் ஆட்டிய நயம் தேங்காய் எண்ணெய்',
    qty: '',
    button: '100ml/50ml'
  }
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: 'petbottle',
    name: 'Coconut Oil - Bottle ',
    desc:
    'தேர்ந்தெடுக்கப்பட்ட தேங்காயை தூய்மையான முறையில் இயற்கையான சூரிய ஔியில் காய வைத்து தயாரான தரமான கொப்பரையை கொண்டு பாரம்பரிய முறையில் செக்கில் ஆட்டிய நயம் தேங்காய் எண்ணெய்',
    qty: '',
    button: '200ml/500ml/1Ltr'
  },
  {
    img: sweet3,
    alt: 'Petbottle gingelly',
    name: 'GINGELLY OIL - Bottle ',
    desc:
      'நயம் எள்ளுடன் மண்டவெல்லம் சேர்த்து செக்கில் ஆட்டிய நல்லெண்ணெய்',
    qty: '',
    button: '500ml/1Ltr'
  },
  {
    img: sweet1,
    alt: 'petbottle groundnut',
    name: 'GROUNDNUT OIL - Bottle ',
    desc:
      'தேர்ந்தெடுக்கப்பட்ட கடலையை கொண்டு செக்கில் ஆட்டிய நயம் கடலை எண்ணெய்',
    qty: '',
    button: '500ml/1ltr'
  }
];
